module.exports = __webpack_public_path__ + "static/img/sensorBlockLinkage.1b9941e3.svg";